var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronLeftBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15C7.71875 15 7.46875 14.9062 7.28125 14.7188L1.28125 8.71875C0.875 8.34375 0.875 7.6875 1.28125 7.3125L7.28125 1.3125C7.65625 0.90625 8.3125 0.90625 8.6875 1.3125C9.09375 1.6875 9.09375 2.34375 8.6875 2.71875L3.40625 8L8.6875 13.3125C9.09375 13.6875 9.09375 14.3438 8.6875 14.7188C8.5 14.9062 8.25 15 8 15Z",
    fill: "url(#paint0_linear_3189_23690)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3189_23690",
    x1: 6,
    y1: -2,
    x2: 6,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2B63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronLeftBlack);
export default __webpack_public_path__ + "static/media/icon-chevron-left-black.16e3aff60be4820cadb97a6707df0f56.svg";
export { ForwardRef as ReactComponent };